import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'primeng/tooltip';
import { FormlyCustomValidationMessageComponent } from '@shared/formly/formly-custom-types/formly-custom-validation-message.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'formly-wrapper-form-field',
  template: `
    <div class="form-group" [class.has-error]="showError">
      <label *ngIf="props.label && props.hideLabel !== true && props.dummyLabel !== true" [attr.for]="itemLabelPrefix + elementId">
        <span *ngIf="props.required && props.hideRequiredMarker !== true" class="wcag-visuallyhidden">Required field, </span>
        <span [innerHTML]="props.label | translate"></span>
        <span *ngIf="props.required && props.hideRequiredMarker !== true" aria-hidden="true">*</span>:
        <fa-icon
          *ngIf="props.icon"
          pTooltip="{{props.icon?.text | translate}}"
          tooltipStyleClass="tooltip-min-width"
          [escape]="false"
          tooltipPosition="{{props.icon?.tooltipPosition ? props.icon?.tooltipPosition : 'top'}}"
          [icon]="props.icon?.iconProp ? props.icon.iconProp : ['fas', 'info-circle']">
        </fa-icon>
      </label>
      <label *ngIf="props.label && props.dummyLabel === true" [attr.for]="itemLabelPrefix + elementId" class="wcag-visuallyhidden">
        <span [innerHTML]="props.label"></span>
      </label>
      <input *ngIf="props.dummyInputForLabel" [id]="itemLabelPrefix + elementId" class="wcag-visuallyhidden" tabindex="-1">
      <ng-template #fieldComponent></ng-template>
      <div *ngIf="showError" class="invalid-feedback" [style.display]="'block'">
        <formly-custom-validation-message [field]="field"></formly-custom-validation-message>
      </div>
      <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
    </div>
  `,
  imports: [TranslateModule, CommonModule, FontAwesomeModule, TooltipModule, FormlyCustomValidationMessageComponent,
    FormsModule, ReactiveFormsModule, FormlyModule ]
})
export class FormlyWrapperFormFieldComponent extends FieldWrapper {

  get itemLabelPrefix(): string {
    return this.props.itemLabelPrefix ? `${this.props.itemLabelPrefix}_` : '';
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      if (!prefix && this.field.parent.parent && this.field.parent.parent.type === 'form-array') {
        prefix = this.field.parent['id'];
      }

      return `${prefix ? prefix + '_' : ''}${(this.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }

}
